import { createSlice } from "@reduxjs/toolkit";

const initState = {
  // Integer count of in-flight requests (never use boolean — `false + 1` is 1,
  // but comparisons like `loadingStatus > 0` must stay numeric).
  pendingLoadRequests: 0,
};

export const loadingRequestsSlice = createSlice({
  name: "loadingRequests",
  initialState: initState,
  reducers: {
    addToLoadRequest: (state) => {
      const current = Number(state.pendingLoadRequests) || 0;
      state.pendingLoadRequests = current + 1;
    },
    removeFromLoadRequest: (state) => {
      const current = Number(state.pendingLoadRequests) || 0;
      state.pendingLoadRequests = Math.max(0, current - 1);
    },
    /** Force-clear stuck loaders after hard failures. */
    resetLoadRequests: (state) => {
      state.pendingLoadRequests = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const loadingRequestsActions = loadingRequestsSlice.actions;

export default loadingRequestsSlice.reducer;
